export const GET_TOP100SONGS_FAIL = "GET_TOP100SONGS_FAIL";
export const GET_TOP100SONGS_SUCCESS = "GET_TOP100SONGS_SUCCESS";
export const GET_SONGSREQUEST_LOADING = "GET_SONGSREQUEST_LOADING";


export const GET_TOP100ALBUMS_FAIL = "GET_TOP100ALBUMS_FAIL";
export const GET_TOP100ALBUMS_SUCCESS = "GET_TOP100ALBUMS_SUCCESS";
export const GET_ALBUMSREQUEST_LOADING = "GET_ALBUMSREQUEST_LOADING";